import { useLayoutEffect } from 'react';
import { BrowserRouter, Routes, Route, useSearchParams, useLocation } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import AdList from './components/AdList';
import AdForm from './components/AdForm/AdForm';
import { CreateAdDialog } from './components/CreateAdDialog';
import { ModalStackProvider } from './components/common/Modal';
import { RequestManagerProvider, RequestManager } from './components/common/RequestManager';
import client from './graphqlClient';
import { Bounce, ToastContainer } from 'react-toastify'
import { ImageProvider } from './components/ImageTools/ImageProvider';
import OrderList from './components/OrderList';
import ImportOrderList from './components/ImportOrderList';
import OrderPage from './components/OrderPage/OrderPage';
import TasksList from './components/TasksList';
import TaskModal from './components/TaskModal';
import GlobalSearch from './components/GlobalSearch';
import { useGlobalSearch } from './hooks/useGlobalSearch';
import LoginPage from './components/LoginPage';
import LoggedInRoute from './components/LoggedInRoute';
import PublicHome from './components/PublicHome/PublicHome';
import ConnectAliexpressAccount from './components/ConnectAliexpressAccount';
import Stats from './components/Stats';
import ConnectEbayAccount from './components/ConnectEbayAccount';
import CalculatorPage from './components/CalculatorPage';
import ShippingRatesPage from './components/ShippingRatesPage';
import ProcessesPage from './components/Processes/ProcessesPage';
import ProcessModal from './components/Processes/ProcessModal';
import RestockShipmentsList from './components/RestockShipments/RestockShipmentsList';
import RestockShipmentFormPage from './components/RestockShipments/RestockShipmentFormPage';
import ImportTransactionsPage from './components/ImportTransactionsPage';
import ModalRouter from './ModalRouter';
import { Helmet } from 'react-helmet';
import VerifyDataIntegrityPage from './components/VerifyDataIntegrityPage';
import OrdersStatsPage from './components/OrdersStatsPage';
import ShopsPage from './components/Shops/ShopsPage';

function App() {
  const { isSearchOpen, closeSearch } = useGlobalSearch();
  console.log('APP ENV', import.meta.env.VITE_APP_ENV);
  console.log('API URL', import.meta.env.VITE_API_URL);

  useLayoutEffect(() => {
    if (import.meta.env.VITE_APP_ENV === 'local') {
      document.querySelector('link[rel="icon"]')?.setAttribute('href', '/favicon-dev.png');
    }
  }, []);

  // const location = useLocation();
  // // Reset title
  // useLayoutEffect(() => {
  //   document.title = 'Wow Magasin';
  // }, [location]);

  

  return (
    <div className="min-h-screen bg-gray-100">
      <Helmet>
        <title>Wow Magasin</title>
      </Helmet>
      <ModalRouter>
        <Routes>
          <Route path="/" element={<PublicHome />} />
          <Route path="/login" element={<LoginPage />} />

          <Route element={<LoggedInRoute />}>
            <Route path="/connect-aliexpress" element={<ConnectAliexpressAccount />} />
            <Route path="/connect-ebay" element={<ConnectEbayAccount />} />
            <Route path="/ads" element={<AdList />} />
            <Route path="/ads/new" element={<CreateAdDialog />} />
            <Route path="/ad/:id/edit/:step?" element={<AdForm />} />
            <Route path="/orders" element={<OrderList />}/>
            <Route path="/orders/:orderId" element={<OrderPage />}>
              <Route path="tasks/:taskId" element={<TaskModal />} />
            </Route>
            <Route path="/import-orders" element={<ImportOrderList />}>
            </Route>
            <Route path="/calculator" element={<CalculatorPage />} />
            <Route path="/shipping-rates" element={<ShippingRatesPage />} />
            <Route path="/tasks" element={<TasksList />}>
              <Route path=":taskId" element={<TaskModal />} />
            </Route>
            <Route path="/processes" element={<ProcessesPage />}>
              <Route path=":processId" element={<ProcessModal />} />
            </Route>
            <Route path="/restock-shipments" element={<RestockShipmentsList />} />
            <Route path="/restock-shipments/new" element={<RestockShipmentFormPage />} />
            <Route path="/restock-shipments/:id/edit" element={<RestockShipmentFormPage />} />
            <Route path="/restock-shipments/:id/boxes" element={<RestockShipmentFormPage />} />
            <Route path="/stats" element={<Stats />} />
            <Route path="/orders-stats" element={<OrdersStatsPage />} />
            <Route path="/import-tx" element={<ImportTransactionsPage />} />
            <Route path="/verify-data-integrity" element={<VerifyDataIntegrityPage />} />
            <Route path="/shops" element={<ShopsPage />} />
          </Route>
        </Routes>
      </ModalRouter>

      {/* Global Search Overlay */}
      <GlobalSearch isOpen={isSearchOpen} onClose={closeSearch} />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Bounce}
      />
    </div>
  );
}

function AppWrapper() {
  return (
    <ImageProvider>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <ModalStackProvider>
            <RequestManagerProvider>
              <App />
              <RequestManager />
            </RequestManagerProvider>
          </ModalStackProvider>
        </BrowserRouter>
      </ApolloProvider>
    </ImageProvider>
  );
}

export default AppWrapper;